import { Container } from '@material-ui/core';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { useParams } from 'react-router-dom';
import { OrgUserDetailsProvider } from 'src/hooks/useOrgUserDetails';
import OrgUserDetailsLoader from '../OrgUserDetails/OrgUserDetailsLoader';

const UserDetailsPage: React.FC = () => {
  const { UID } = useParams();

  return (
    <Container disableGutters maxWidth="xl">
      <OrgUserDetailsProvider userId={UID}>
        <OrgUserDetailsLoader />
      </OrgUserDetailsProvider>
    </Container>
  );
};

export default hot(UserDetailsPage);
